<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Dealer Group Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealergroup_edit.Name.$error
                    }"
                    v-model="dealer.dealergroup_edit.Name"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="Name"
                    @change.native="addDirtyField"
                    @input="$v.dealer.dealergroup_edit.Name.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Notes</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealergroup_edit.Notes"
                    placeholder=""
                    autocomplete="off"
                    type="text"
                    id="Notes"
                    @change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss3CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss3Countdown = 0)"
              @dismiss-count-down="countDown3Changed"
            >
              Dealer Group already exists! Your information could not be saved.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="12">
        <h3 v-if="dealer.dealergroup_edit.DealerGroupID > 0">
          Members of {{ dealer.dealergroup_edit.Name }}
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="dealer.dealergroup_edit.Members"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          v-if="dealer.dealergroup_edit.DealerGroupID > 0"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Remove"
              class="fa fa-minus-circle localMinusSign"
              @click.stop="SetItemToRemove(data.item)"
            ></i>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="12">
        <h2></h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group>
          <b-input-group>
            <b-form-input
              v-if="dealer.dealergroup_edit.DealerGroupID > 0"
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  v-if="dealer.dealergroup_edit.DealerGroupID > 0"
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="NotIncluded"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
          v-if="dealer.dealergroup_edit.DealerGroupID > 0"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Add"
              class="fa fa-plus-circle localPlusSign"
              @click.stop="SetItemToAdd(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <!-- <UserListSubset :group_object="dealer.dealergroup_edit" /> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmployeeCard from "@/components/cards/EmployeeCard.vue";

import { required, email, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "DealerGroupProfile",
  components: {
    EmployeeCard,
    CoolSelect
  },
  created() {
    this.myLoadComponent();
  },
  data() {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "InternalDealerID",
          label: "BDS ID",
          sortable: true,
          thStyle: "width: 15%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "Name",
          label: "Name",
          sortable: true,
          thStyle: "width: 25%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "State",
          label: "State",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "PostalCode",
          label: "Zip",
          sortable: true,
          thStyle: "width: 10%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        },
        {
          key: "EmailMain",
          label: "Email",
          sortable: true,
          thStyle: "width: 20%;",
          thClass: "ellipse_cell",
          tdClass: "ellipse_cell"
        }
      ],
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false,
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: ""
    };
  },
  mounted() {
    this.$store.state.saveOp.localUrl = "/Dealer/Group/Save/";
    this.$store.state.saveOp.localVariableName = "_dg";
    this.$store.state.saveOp.localVariableObject = this.$store.state.dealer.dealergroup_edit;
    this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    this.$store.state.saveOp.localFieldToSet = "DealerGroupID";
    this.$store.state.saveOp.localReturnObject = "SaveDealerGroupResult";
  },
  methods: {
    myRowClickHandler(record, index, event) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("dealer/loadDealerEdit", record.DealershipID)
        .then(() => {
          this.$router.push({ name: "DealerProfile" });
        });
    },

    async SetItemToAdd(object) {
      this.$store.state.dealer.dealergroup_edit.Members.push(object);

      var _op = {
        DealerGroupID: this.$store.state.dealer.dealergroup_edit.DealerGroupID,
        DealershipID: object.DealershipID,
        Include: true
      };

      await this.$store.dispatch("dealer/adjustGroupMembers", _op);
    },
    async SetItemToRemove(object) {
      this.$store.state.dealer.dealergroup_edit.Members = this.$store.state.dealer.dealergroup_edit.Members.filter(
        d => d.DealershipID !== object.DealershipID
      );

      var _op = {
        DealerGroupID: this.$store.state.dealer.dealergroup_edit.DealerGroupID,
        DealershipID: object.DealershipID,
        Include: false
      };

      await this.$store.dispatch("dealer/adjustGroupMembers", _op);
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.dealer.dealers;

      this.filteredObjects = this.filteredObjects.filter(
        dealer =>
          dealer.Name.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          dealer.InternalDealerID.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          dealer.State.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          dealer.PostalCode.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      if (
        this.$store.state.dealer.dealergroup_edit.UserGroupID !== -1 &&
        this.$store.state.dealer.dealergroups.find(
          group =>
            group.DealerGroupID !==
              this.$store.state.dealer.dealergroup_edit.DealerGroupID &&
            group.Name.toLowerCase() ===
              this.$store.state.dealer.dealergroup_edit.Name.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );
      }
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
    },
    async myLoadComponent() {
      await this.$store.dispatch("dealer/fetchDealers");
      this.filterList();
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  },
  computed: {
    ...mapState(["n_user", "dealer", "saveOp"]),
    ...mapActions("dealer", ["SaveDealerGroup"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    totalRows: function() {
      return this.$store.state.dealer.dealers.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    NotIncluded() {
      var _ni = this.filteredObjects;
      this.$store.state.dealer.dealergroup_edit.Members.forEach(m => {
        _ni = _ni.filter(ni => ni.DealershipID != m.DealershipID);
      });
      return _ni;
    }
  },

  validations: {
    dealer: {
      dealergroup_edit: {
        Name: {
          required
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
</style>
